import StarRating from "@components/StarRating"
import { twMerge } from "tailwind-merge"

interface Props {
  logo: string
  logoAlt: string
  rating: string
  ratingsCount: string
  colorClass: string
}

export default function StoreRating({
  logo,
  logoAlt,
  rating,
  ratingsCount,
  colorClass,
}: Props) {
  return (
    <div className="flex flex-col items-center gap-4 rounded-2xl border border-gray-200 bg-white px-6 py-5 shadow-xs">
      <div className="flex items-center gap-2">
        <span className={twMerge("text-2xl font-semibold", colorClass)}>
          {rating}
        </span>
        <img src={logo} alt={logoAlt} className="h-8 w-8" />
      </div>
      <StarRating rating={4.5} />
      <p className="text-text-secondary text-center text-sm">{ratingsCount}</p>
    </div>
  )
}
